import * as actionTypes from "../actions/actionTypes";
import { pathOr } from 'ramda';
const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  config: null,
  configLoading: false,
  configError: null,
  currentUserData: null,
  currentUserLoading: false,
  currentUserError: null,
  themeConfig: {
    currentTheme: "simpleX",
  },
  userPreference: {},
  userPreferenceLoading: false,
  userPreferenceError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_METACONFIG_FAILURE:
      return { ...state, configLoading: false, configError: action.error };
    case actionTypes.GET_METACONFIG_REQUEST:
      return { ...state, configLoading: true };
    case actionTypes.GET_METACONFIG_SUCCESS:
      return {
        ...state,
        configLoading: false,
        config: action.payload,
        configError: null,
      };

    case actionTypes.GET_CURRENTUSER_FAILURE:
      return {
        ...state,
        currentUserLoading: false,
        currentUserError: action.error,
      };

    case actionTypes.GET_CURRENTUSER_REQUEST:
      return { ...state, currentUserLoading: true };

    case actionTypes.GET_CURRENTUSER_SUCCESS:
      return {
        ...state,
        currentUserLoading: false,
        currentUserData: action.payload,
        currentUserError: null,
      };

    case actionTypes.TOGGLE_THEME:
      return {
        ...state,
        themeConfig: { currentTheme: action.payload },
      };
    case actionTypes.USER_PREFERENCE_REQUEST:
      return { ...state, dashboardLoading: true,userPreferenceLoading:true };

    case actionTypes.USER_PREFERENCE_SUCCESS:
      
      let calendar_format='';
      let time_reg_format = '([0-9]{1,2}):([0-9]{1,2})';
      let date_reg_format = '([0-9]{1,2})/([0-9]{1,2})/([0-9]{4})';
      let date_reg_positions = { 'm': 1,'d': 2,'Y': 3 };

      window.calendar_format = pathOr(calendar_format, ['attributes', 'global','calendar_format'], action.payload);
	    window.date_reg_format = pathOr(date_reg_format, ['attributes', 'global','date_reg_format'], action.payload);
	    window.time_reg_format = pathOr(time_reg_format, ['attributes', 'global','time_reg_format'], action.payload);
	    window.date_reg_positions = pathOr(date_reg_positions, ['attributes', 'global','date_reg_positions'], action.payload);
      
      return {
        ...state,
        userPreferenceError: null,
        userPreferenceLoading: false,
        userPreference: {
          ...state.userPreference,
          ...action.payload,
        },
      };

    case actionTypes.USER_PREFERENCE_FAILURE:
      return {
        ...state,
        userPreferenceLoading: false,
        userPreferenceError: action.error,
      };

    case actionTypes.UPDATE_BASE_URL:
      return { ...state, baseUrl: action.baseUrl };
    default:
      return state;
  }
};
